"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.US_STRATEGIST_TEMPLATES = exports.US_STRATEGIST_TEMPLATES_MD = void 0;
exports.US_STRATEGIST_TEMPLATES_MD = {
    'Year Start Meeting (YSM)': `* Three Key Goals for the Year\n
* Timeline for the Year\n
* Academic Update\n
* Extracurricular Update\n
\t* ECL Mentor Allocation\n
\t* Project type\n
\t* Student's region (actual location)\n
\t* Preference for mentor (major-matching requirement, other requirements) - optional\n
* Standardized Testing Update`,
    'Initial Strategy Meeting (ISM)': `* Introductions\n
* Strategist vs. SSM Role\n
* Academic Strengths & Weaknesses\n
* ECs and Personal Interests\n
\t* ECL Mentor Allocation\n
\t* Project type\n
\t* Preference for mentor (major-matching requirement, other requirements) - optional\n
* Initial Majors, Careers, Schools Discussion\n
* The Application Process\n
* Preliminary Hook Statement Activity\n
* Resources & Recommendations\n
* Next steps and task setting`,
    'Pathfinder Meeting': `* Introducing Pathfinder\n
* What Admissions Officers Look For\n
* Review Pathfinder and mark off achieved goals\n
* ECs\n
\t* ECL Mentor Allocation\n
\t* Project type\n
\t* Preference for mentor (major-matching requirement, other requirements) - optional\n
* Establish 3-5 new goals\n
* Establish expectations around Pathfinder use during strategy\n
* Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals\n
* Review common/expected deadlines (eg. key US deadlines for schools of interest)\n
* Review and send the respective NAY or AY timelines\n
* Other Check-in Items`,
    'NAY: Meeting': `#### Check-in\n
* Academics\n
* Extracurriculars\n
* Leadership project\n
* Major/Career Goals\n
* Hook statement\n
* School research\n
* Summer plans\n
* Testing\n
* Writing\n
#### Meeting Focus Area: Insert topic here
`,
    'NAY: Mid Review Meeting': `#### Check-in\n
* Academics\n
* Extracurriculars\n
* Leadership project\n
* Major/Career Goals\n
* Hook statement\n
* School research\n
* Summer plans\n
* Testing\n
* Writing\n
#### First Half of the Year Reflection\n
* Candidacy Assesment\n
* Progress on YSM Goals\n
#### Meeting Focus Area: Insert topic here`,
    'AY: EC Alignment': `#### Extracurricular Alignment\n
* EC Discussion and Cataloging\n
* Action Plan for Optimization (by August)\n
* Summer Activities (if applicable)\n
#### Additional Check-ins\n
* Standardized Testing`,
    'AY: Timeline Alignment': `#### App Year Timeline Alignment\n
* Student Handbook\n
* Who's Who\n
* App Year Timeline\n
* Current Application Assessment\n
* Writing 101\n
* Questions`,
    'AY: Writing Alignment': `#### Writing Requirements for College Apps\n
* Why Essays Are Important\n
* Essay Types\n
* Deadline Review\n
* Model Essay Examples\n
#### Writing 101 Feedback\n
* Feedback, Next Steps, and Q&A\n
#### Additional Check-ins\n
* Testing Realignment (if necessary)\n
* Summer Plan Review (if applicable)`,
    'AY: School Research': `#### School Research\n
* Creating a School List\n
* 13 Factors to Consider\n
* Choosing Factors\n
* College/Major Research`,
    'AY: Pre-Application Details': `#### Pre-Application Details\n
* The Hook Statement\n
* Finalizing Personal Statement Topic\n
* Letters of Recommendation: Selecting & Contacting Recommenders\n
* Financial Aid/Need\n
* Basic Financial Forms \n
* Dream School Selection\n
* School Research`,
    'AY: Application Portals': `#### Application Portals\n
* Answering Common App/Portal Questions\n
#### Progress Check-up\n
* Testing\n
* Essay Progress\n
* School Research\n
* EA/ED Confirmation`,
    'AY: School List Confirmation and Submission Requirements': `#### School List Confirmation and Submission Requirements\n
* Confirmed School List\n
* Financial Aid Application Check\n
* Review of Deadlines, Workload, and Additional Submissions\n
* Recommender, Counselor, and School Profile Confirmation`,
    'AY: Activity List/Honors/Awards/Additional Information': `#### Finalizing Common App for EA/ED Submissions\n
* Activities Section\n
* Honors and Awards Section\n
* Additional Information Section\n
* EA/ED Application Finalization`,
    'AY: EA/ED Submission': `#### Finalizing EA/ED Submissions\n
* Final Application Review\n
* Submission Ready?\n
* Upcoming Dates, Deadlines, and Requirements`,
    'AY: Post EA/ED and UC Submission': `#### Finalizing UC Submissions\n
* UC Portal Review\n
* UC Campus/Major Selection\n
* UC Combined Activities/Awards Page\n
* Submission Ready?\n
#### Additional Submissions\n
* December 1st Submissions\n
* Interview Preparation Check-in\n
#### Essays\n
* RD Supplement Plan`,
    'AY: Post UC Submission EA / ED Decision Release and Pre - RD': `#### Post-UC / Pre-RD Applications\n
* EA/ED Results & Strategy\n
* Deferral Process\n
* RD Essays & Requirements\n
* Common App/Portal Review\n
* Submission Ready?`,
    'AY: RD Submission': `#### Finalizing RD Submissions\n
* Finalizing Application Materials\n
* Additional Questions\n
* Submission Ready?\n
* Upcoming Dates, Deadlines, and Requirements`,
    'AY: Post - RD': `#### Post-RD Submission\n
* Next Steps\n
* Letter of Continued Interest\n
* Possible Service Transfers`,
    'AY: Offer Review': `* Discussion of all Admission Outcomes\n
* Final Choices\n
* Other Crimson Opportunities`,
    'AY: Other Meeting': '* N/A',
    'AY: Final Meeting Before Contract End': `* Final Questions and Guidance Needed\n
* Other Crimson Opportunities\n
* Good Luck and Stay in Touch!
  `,
    Other: '* N/A',
};
exports.US_STRATEGIST_TEMPLATES = {
    'Year Start Meeting (YSM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Three Key Goals for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Timeline for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Academic Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Extracurricular Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'ECL Mentor Allocation',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Project type',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Preference for mentor (major-matching requirement, other requirements) - optional',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Standardized Testing Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Academic Strengths & Weaknesses',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'ECs and Personal Interests',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Capstone Advisor Allocation',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Capstone Project type',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Preference for Capstone Mentor (major-matching requirement, other requirements)',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Initial Majors, Careers, Schools Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'The Application Process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Preliminary Hook Statement Activity',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Resources & Recommendations',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Next steps and task setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Pathfinder Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introducing Pathfinder',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'What Admissions Officers Look For',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Review Pathfinder and mark off achieved goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'ECs',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'ECL Mentor Allocation',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Project type',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Preference for mentor (major-matching requirement, other requirements) - optional',
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 new goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Establish expectations around Pathfinder use during strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Review common/expected deadlines (eg. key US deadlines for schools of interest)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Review and send the respective NAY or AY timelines',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 10,
            type: 'p',
            children: [
                {
                    text: 'Other Check-in Items',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Meeting': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Check-in',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Leadership project',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Major/Career Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Hook statement',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'School research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Summer plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Writing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Meeting Focus Area: Insert topic here',
                },
            ],
            indent: 0,
        },
    ],
    'NAY: Mid Review Meeting': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Check-in',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Leadership project',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Major/Career Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Hook statement',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'School research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Summer plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Writing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'First Half of the Year Reflection',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assesment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Progress on YSM Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Meeting Focus Area: Insert topic here',
                },
            ],
            indent: 0,
        },
    ],
    'AY: EC Alignment': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Extracurricular Alignment',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'EC Discussion and Cataloging',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Action Plan for Optimization (by August)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Summer Activities (if applicable)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Additional Check-ins',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Standardized Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Timeline Alignment': [
        {
            type: 'h4',
            children: [
                {
                    text: 'App Year Timeline Alignment',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Student Handbook',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: "Who's Who",
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'App Year Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Current Application Assessment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Writing 101',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Writing Alignment': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Writing Requirements for College Apps',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Why Essays Are Important',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Types',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Deadline Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Model Essay Examples',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Writing 101 Feedback',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Feedback, Next Steps, and Q&A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Additional Check-ins',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Testing Realignment (if necessary)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Summer Plan Review (if applicable)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: School Research': [
        {
            type: 'h4',
            children: [
                {
                    text: 'School Research',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Creating a School List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: '13 Factors to Consider',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Choosing Factors',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'College/Major Research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Pre-Application Details': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Pre-Application Details',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'The Hook Statement',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Finalizing Personal Statement Topic',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Letters of Recommendation: Selecting & Contacting Recommenders',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Financial Aid/Need',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Basic Financial Forms',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Dream School Selection',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'School Research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Application Portals': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Application Portals',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Answering Common App/Portal Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Progress Check-up',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Progress',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'School Research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'EA/ED Confirmation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: School List Confirmation and Submission Requirements': [
        {
            type: 'h4',
            children: [
                {
                    text: 'School List Confirmation and Submission Requirements',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Confirmed School List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Financial Aid Application Check',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Review of Deadlines, Workload, and Additional Submissions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Recommender, Counselor, and School Profile Confirmation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Activity List/Honors/Awards/Additional Information': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Finalizing Common App for EA/ED Submissions',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Activities Section',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Honors and Awards Section',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Additional Information Section',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'EA/ED Application Finalization',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: EA/ED Submission': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Finalizing EA/ED Submissions',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Application Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Submission Ready',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Upcoming Dates, Deadlines, and Requirements',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post EA/ED and UC Submission': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Finalizing UC Submissions',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'UC Portal Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'UC Campus/Major Selection',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'UC Combined Activities/Awards Page',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Submission Ready?',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Additional Submissions',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'December 1st Submissions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Interview Preparation Check-in',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Essays',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'RD Supplement Plan',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post UC Submission EA / ED Decision Release and Pre - RD': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Post-UC / Pre-RD Applications',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'EA/ED Results & Strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Deferral Process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'RD Essays & Requirements',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Common App/Portal Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Submission Ready?',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: RD Submission': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Finalizing RD Submissions',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Finalizing Application Materials',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Additional Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Ready?',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Upcoming Dates, Deadlines, and Requirements',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post - RD': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Post-RD Submission',
                },
            ],
            indent: 0,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Next Steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Letter of Continued Interest',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Possible Service Transfers',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Offer Review': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all Admission Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Final Choices',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Other Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Final Meeting Before Contract End': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Questions and Guidance Needed',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Good Luck and Stay in Touch!',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=us-strategist.js.map